import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as moment from "moment";
import { Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../../../../../components/Spinner";
import { adminFetchLocationListApi, invoiceTableRecords, invoiceStausUpdateApiFunc } from "redux/actions/adminPtPlusOrderRequests";

import styled from "styled-components";
import Pagination from "web/components/Pagination";
import AlertModal from "web/components/AlertModal";
import { storeAdminDetails, logoutAdmin } from 'redux/actions/admin';
import InvoiceTable from "./invoiceTable";
import { InvoiceTableContainer } from "./invoiceTable/InvoiceTableStyle";
import { InvoiceActionWrapper, SearchWrapper, SelectWrapper } from "./OrderStyled";
import { DateWrapper } from "web/pages/private/Admin/DashBoard/dashBoardStyled";
import DropDown from "web/components/DropDown";
import MultiSelect from "./headingSection/MultiSelect";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import DatePicker from "web/components/DatePicker";
import { AiOutlineSearch } from "react-icons/ai";

function OrderInvoices({ TabPanel, value }) {
  const dispatch = useDispatch();
  let history = useHistory();
  const customerId = localStorage.getItem("customerId");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const adminRoles = useSelector((state) => state.admin.adminRoles);

  let headerArr = [
    "Customer Name",
    "Del/Pickup Location",
    "Invoice Number",
    "Order Number",
    "PO Number",
    "Invoice Date",
    "Invoice Period",
    "No. Of Loads",
    "TotalAmount(Inc.Tax/Fee)",
    "Invoice Status",
    "Payment Date",
    "Download Invoice",
  ];
  let filterDropDown = [
    {
      label: "All",
      value: null
    },
    {
      label: "By Order",
      value: "DAILY"
    },
    {
      label: "Weekly",
      value: "WEEKLY"
    },
    {
      label: "Monthly",
      value: "MONTHLY"
    },
  ]
  let invoiceDropDown = [
    {
      label: "All",
      value: null
    },
    {
      label: "Paid",
      value: "PAID"
    },
    {
      label: "Unpaid",
      value: "UNPAID"
    }
  ]
  let orderTypeDropDown = [
    {
      label: "Order Type (All)",
      value: null
    },
    {
      label: "Delivery",
      value: "DELIVERY"
    },
    {
      label: "Pickup",
      value: "PICKUP"
    }
  ]
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState("");
  const token = localStorage.getItem("token");
  const [tableSearch, setTableSearch] = useState('')

  let toDatePtPlusInvoice = new Date();
  let fromDatePtPlusInvoice = new Date();
  fromDatePtPlusInvoice.setMonth(fromDatePtPlusInvoice.getMonth() - 6)
  const [startDateValue, setStartDateValue] = useState(moment(fromDatePtPlusInvoice).format("MM/DD/YYYY"))
  const [endDateValue, setEndDateValue] = useState(moment(toDatePtPlusInvoice).format("MM/DD/YYYY"))

  const [sortBy, setSortBy] = useState("")
  const [invStatus, setInvStatus] = useState("")
  const [pageNumber, setPageNumber] = useState(1);
  let obj = [{ label: "", value: "", arrList: "" }]
  const [locationRes, setLocationsRes] = useState(obj);
  const [selectedLocation, setSelectedLocation] = useState();
  const [locationResponse, setLocationResponse] = useState();
  const [allLocationsValue, setAllLocationsValue] = useState([])
  const [multiSelectVal, setMultiSelectVal] = useState(locationRes && locationRes?.length > 0 ? locationRes : []);
  const [locationName, setLocationName] = useState(true);
  const [orderResponse, setOrderResponse] = useState();
  const [totalPagesCount, setTotalPagesCount] = useState(0);

  const [filter, setFilter] = useState({
    locations: [],
    findAll: true,
    size: 10,
    number: 0,
    sort: "DESC",
    status: null,
    orderType: null,
    invoiceSchedule: null,
    searchBy: tableSearch,
    fromDate: moment(fromDatePtPlusInvoice).format("MM/DD/YYYY"),
    toDate: moment(toDatePtPlusInvoice).format("MM/DD/YYYY"),
  });

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    if (!token) {
      adminLogout()
    } else {
      fetchLocationListFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchMyApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (allLocationsValue && allLocationsValue.length > 0) {
      setFilter({
        ...filter,
        number: 0,
        findAll: false,
        locations: allLocationsValue
      });
      setPageNumber(1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLocationsValue]);


  const adminLogout = () => {
    dispatch(storeAdminDetails([], {}))
    dispatch(logoutAdmin())
    localStorage.removeItem('adminRolesData')
    localStorage.removeItem('adminName')
    localStorage.removeItem('adminEmail')
    localStorage.removeItem('token')
    history.push('./sign-in')
    window.location.reload(false);
  }

  const fetchLocationListFunction = async (type) => {
    let response = "";
    response = await dispatch(adminFetchLocationListApi(customerId, token));
    if (response?.success) {
      let locationTemp = response?.data?.customerAndLocations;
      let arr = [];
      for (let i = 0; i < locationTemp.length; i++) {
        let obj = {
          label: locationTemp[i].customer,
          value: locationTemp[i].customerId,
          arrList: locationTemp[i].locationIdAndNames

        };
        arr.push(obj);
        if (i === locationTemp.length - 1) {
          setLocationsRes(arr);
        }
      }
    } else {
      if (response?.statusCode === 401) {
        adminLogout()
      } else {
      }
    }
  };
  const onPageChange = (page) => {
    setFilter({
      ...filter,
      findAll: filter.findAll,
      ["number"]: page - 1,
    });
    setPageNumber(page);
  };

  const handleFilterChange = (name, value, flag) => {
    setFilter(prevFilter => {
      return {
        ...prevFilter,
        number: 0,
        findAll: false,
        [name]: value,
      }
    });
    setPageNumber(1)
  };

  const [isTyping, setIsTyping] = useState();
  const handleSearchChange = e => {
    e.preventDefault()
    setTableSearch(e.target.value)
    setPageNumber(1)
    let searchtext = e.target.value
    if (isTyping) clearTimeout(isTyping);
    const createTypingDebounce = setTimeout(() => {
      setFilter(prevFilter => ({
        ...prevFilter,
        searchBy: searchtext,
        number: 0,
        findAll: false,
      }));
    }, 500);
    setIsTyping(createTypingDebounce)
  }

  const fetchMyApi = async () => {
    let data = JSON.parse(JSON.stringify(filter));
    if (data.fromDate) {
      data.fromDate = (moment(data.fromDate, "MM/DD/YYYY").valueOf()) / 1000;
    }
    if (data.toDate) {
      data.toDate = ((moment(data.toDate, "MM/DD/YYYY").valueOf()) / 1000) + 86399
    }

    let response = await dispatch(invoiceTableRecords(data, token));
    if (response?.data?.success) {
      setOrderResponse(response?.data?.data);
      setTotalPagesCount(response?.data?.data?.totalElements);
    } else {
      if (response?.statusCode === 401) {
        adminLogout()
      } else {
        setTotalPagesCount("");
        setOrderResponse(null);
        setAlertModalContent(response?.data?.error?.message || response.message || 'Something went wrong, please try again!')
        setAlertModal(!alertModal)
      }
    }
  };

  const updatePaymentStatusFunc = async (items, date) => {
    let data = {
      markPaid: true,
      date: date,
      invoiceId: items.invoiceId
    }
    let response = await dispatch(invoiceStausUpdateApiFunc(data, token));
    if (response?.data?.success) {
      fetchMyApi()
      setAlertModalContent('Invoice status marked as paid.')
      setAlertModal(true)
    } else {
      if (response?.statusCode === 401) {
        adminLogout()
      } else {
        setAlertModal(true)
        setAlertModalContent(response?.data?.error?.message);
      }
    }
  }

  return (
    <>
      <TabPanel value={value} index={0}>
        {adminRoles &&
          (adminRoles.includes("SUPER_ADMIN") ||
            adminRoles.includes("PT_PLUS")) ? (
          <div>
            {loaderVisible && <Spinner />}
            <div>
              <InvoiceActionWrapper>
                <div className="action-header">
                  <FormControl
                    variant="standard"
                    sx={{ width: 150 }}
                  >
                    <InputLabel>Sort By</InputLabel>
                    <DropDown
                      name="filterDropDown"
                      data={filterDropDown}
                      searchDropDown={sortBy}
                      searchable={true}
                      placeholder="Sort By"
                      onChangeHandler={(val) => {
                        setSortBy(val?.value)
                        if (val?.value) {
                          handleFilterChange("invoiceSchedule", val?.value)
                        } else {
                          handleFilterChange("invoiceSchedule", val?.value, true)
                        }
                      }}
                    />
                  </FormControl>

                  <SelectWrapper>
                    <div className="date-picker-wrapper">
                      <DatePicker
                        name="fromDatePtPlusInvoice"
                        // maxDOBirth={filter.toDate}
                        maxDOBirth={endDateValue}
                        value={filter.fromDate}
                        inputValue={startDateValue}
                        callBackFun={(date, value) => {
                          setStartDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setFilter(prevFilter => ({
                              ...prevFilter,
                              number: 0,
                              findAll: false,
                              fromDate: moment(date).format("MM/DD/YYYY"),
                            }));
                            setPageNumber(1)
                          }
                          // else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                          //   setFilter(prevFilter => ({
                          //     ...prevFilter,
                          //     number: 0,
                          //     fromDate: null,
                          //   }));
                          // }
                        }}
                      />
                      <DatePicker
                        name="toDatePtPlusInvoice"
                        minDOBirth={startDateValue}
                        value={filter.toDate}
                        inputValue={endDateValue}
                        callBackFun={(date, value) => {
                          setEndDateValue(value)
                          if (moment(date, moment.ISO_8601, true).isValid()) {
                            setFilter(prevFilter => ({
                              ...prevFilter,
                              number: 0,
                              findAll: false,
                              toDate: moment(date).format("MM/DD/YYYY"),
                            }));
                            setPageNumber(1)
                          }
                          // else if (!date || date.toString() === "Invalid Date") { // Check if date is null or undefined
                          //   setFilter(prevFilter => ({
                          //     ...prevFilter,
                          //     number: 0,
                          //     toDate: null,
                          //   }));
                          // }
                        }}
                      />
                    </div>
                  </SelectWrapper>

                  <DateWrapper>
                    <div>
                      <DropDown
                        name="selectCompany"
                        data={locationRes}
                        searchDropDown={selectedLocation}
                        searchable={true}
                        placeholder="Select Company"
                        onChangeHandler={(data) => {
                          setSelectedLocation(data.value)
                          setLocationResponse([])
                          setMultiSelectVal([])
                          let arr = []
                          let subLocationArr = []
                          for (let i = 0; i < data.arrList.length; i++) {
                            let obj = {
                              label: data.arrList[i].locationName,
                              value: data.arrList[i].locationId,
                            }
                            arr.push(obj)
                            subLocationArr.push(data.arrList[i].locationId)
                            if (i === data.arrList.length - 1) {
                              setLocationResponse(arr);
                            }
                          }
                          setAllLocationsValue(subLocationArr)
                        }}
                      />
                    </div>
                  </DateWrapper>
                  <MultiSelect
                    data={locationResponse}
                    name={"selectLocation"}
                    placeholder='Select Location&#42;'
                    multiSelectVal={multiSelectVal}
                    defaultValueArr={multiSelectVal}
                    locationName={locationName}
                    allLocationsValue={allLocationsValue}
                    setMultiSelectVal={(multiSelectVal) => {
                      let result = multiSelectVal.map(item => item.value);
                      if (result.length < 1) {
                        handleFilterChange("locations", allLocationsValue)
                        setMultiSelectVal([])
                      } else {
                        setLocationName(false)
                        handleFilterChange("locations", result)
                        setMultiSelectVal(multiSelectVal)
                      }

                    }}
                    multi={true}
                  />
                  <FormControl
                    variant="standard"
                    sx={{ width: 160 }}
                  >
                    <InputLabel>Order Type</InputLabel>
                    <DropDown
                      name="orderDropDown"
                      data={orderTypeDropDown}
                      searchDropDown={filter?.orderType}
                      searchable={true}
                      placeholder={"Order Type"}
                      onChangeHandler={(val) => {
                        if (val?.value) {
                          handleFilterChange("orderType", val?.value)
                        } else {
                          handleFilterChange("orderType", val?.value, true)
                        }

                      }}
                    />
                  </FormControl>
                  <FormControl
                    variant="standard"
                    sx={{ width: 160 }}
                  >
                    <InputLabel>Invoice Status</InputLabel>
                    <DropDown
                      name="filterDropDown"
                      data={invoiceDropDown}
                      searchDropDown={invStatus}
                      searchable={true}
                      placeholder={"Invoice Status"}
                      onChangeHandler={(val) => {
                        setInvStatus(val?.value)
                        if (val?.value) {
                          handleFilterChange("status", val?.value)
                        } else {
                          handleFilterChange("status", val?.value, true)
                        }

                      }}
                    />
                  </FormControl>
                  <SearchWrapper>
                    <input
                      type="text"
                      placeholder='Search'
                      value={tableSearch}
                      onChange={handleSearchChange}
                    />
                    <AiOutlineSearch />
                  </SearchWrapper>
                </div>
              </InvoiceActionWrapper>
              <InvoiceWrapper>
                {orderResponse?.invoiceList &&
                  orderResponse?.invoiceList.length !== 0 ? (
                  <InvoiceTable
                    headerArr={headerArr}
                    orderResponse={orderResponse}
                    callBackInvoice={(items, date) => {
                      updatePaymentStatusFunc(items, date)
                    }}
                  />
                ) : (
                  <InvoiceTableContainer>
                    <Table responsive style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          {headerArr.map((items, index) => (
                            <th key={index}>{items}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        <td style={{ textAlign: "center" }}></td>
                        <td style={{ textAlign: "center" }}></td>
                        <td style={{ textAlign: "center" }}></td>
                        <td style={{ textAlign: "center" }}></td>
                        <td style={{ textAlign: "center" }}>
                          <p
                            style={{
                              // position: "absolute",
                              width: "100%",
                              textAlign: "center",
                              marginTop: "40px"
                            }}
                          >
                            No records found
                          </p>
                        </td>
                      </tbody>
                    </Table>
                  </InvoiceTableContainer>

                )}
              </InvoiceWrapper>

              {totalPagesCount && totalPagesCount !== 0 && (
                <Pagination
                  totalPage={totalPagesCount}
                  currentPage={pageNumber}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        ) : (
          <p>You are not authorized to view this page.</p>
        )}
        <AlertModal
          isOpen={alertModal}
          toggle={() => setAlertModal(!alertModal)}
          title=""
          content={alertModalContent}
        />
      </TabPanel>
    </>
  );
}

export default OrderInvoices;

export const InvoiceWrapper = styled.div`
  background: #ffffff;
  border: 1px solid rgba(211, 211, 211, 0.5);
`;
